/**
 * Global Data — tab registry.
 *
 * The Global Data shell is a generic host; each reusable-data module registers a
 * tab here. Adding a new module is a one-line addition to this array (plus its
 * provider in GlobalDataProviders) — the shell renders whatever is registered.
 */

import type { ComponentType } from 'react';

export interface GlobalDataTab {
  /** Stable tab id. */
  id: string;
  /** Tab label shown in the navigation. */
  label: string;
  /** Body component rendered when the tab is active. */
  Component: ComponentType;
}

/**
 * Empty since 2026-10-02: the only module, Cartel Items, was retired in favour of
 * the SWTORBIT platform's item catalogue (PLATFORM_INTEGRATION.md, Phase 2). The
 * menu entry hides itself while this list is empty; add a module here to bring
 * the area back.
 */
export const GLOBAL_DATA_TABS: GlobalDataTab[] = [];
